export default __webpack_public_path__ + "6fb67da.png";